// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"vendors-node_modules_libzeropool-rs-wasm-web-mt_libzeropool_rs_wasm_mt_js":"ada19207","vendors-node_modules_libzeropool-rs-wasm-web-mt_snippets_wasm-bindgen-rayon-7afa899f36665473_-bf1758":"00fd01d9"}[chunkId] + ".chunk.js";
};